import * as Sentry from "@sentry/react";

import "semantic-ui-less/semantic.less";

import "react-datepicker/dist/react-datepicker.css";
import "react-phone-number-input/style.css";
import { Outlet } from "react-router-dom";

import Footer from "./components/Footer";
import OfflineMessage from "./components/OfflineMessage";
import UpdateMessage from "./components/UpdateMessage";
import "./css/global.css";
import useCrisp from "./features/crisp/hooks/useCrisp";
import useScrollToTop from "./features/ui/hooks/useScrollToTop";

function App() {
	useCrisp();
	useScrollToTop();

	return (
		<div>
			<UpdateMessage />
			<OfflineMessage />

			<Outlet />

			<Footer />
		</div>
	);
}

export default Sentry.withProfiler(App);
